import { Grid, Typography } from "@mui/material";
import React, { FC } from "react";
import { IClubMembers } from "../../common/interfaces/club.interface";
import AppCard from "../cards/AppCard";

const ClubMembers: FC<{ clubMembers: IClubMembers }> = ({ clubMembers }) => {
  return (
    <div>
      <Typography variant="subtitle1" my={1}>
        Members
      </Typography>
      <Grid
        container
        spacing={{ xs: 1, md: 2, sm: 2 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
      >
        <Grid item xs={12} sm={12} md={4.5}>
          <AppCard
            label={"Total number of club members"}
            value={clubMembers.total.toString()}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={2.5}>
          <AppCard label={"Founder"} value={clubMembers.founder.toString()} />
        </Grid>
        <Grid item xs={12} sm={12} md={2.5}>
          <AppCard label={"Manager"} value={clubMembers.manager.toString()} />
        </Grid>
        <Grid item xs={12} sm={12} md={2.5}>
          <AppCard label={"Member"} value={clubMembers.member.toString()} />
        </Grid>
      </Grid>
    </div>
  );
};

export default ClubMembers;
